// Navbar.tsx
import React from 'react';
import { IMAGES_PATH } from 'configs/imagesPath';
import { PATH_NAME } from 'configs/pathName';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import { connect, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { handleCartList, handleSignupModal } from 'redux/actions/auth.action';
import { USER_ROLE } from 'configs/userRole';
import { IconButton } from '@mui/material';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import './styles.scss';
import authService from 'services/authService';

type Anchor = 'top' | 'left' | 'bottom' | 'right';

const MainNavbar = ({ isLoggedIn, cartItems = [], user }: any) => {
  const role = authService.getRole();
  const dispatch = useDispatch();
  const history = useHistory();
  const openCart = () => {
    isLoggedIn && dispatch(handleCartList(true));
  };
  const handleLogout = () => {
    authService.logOut();
    history.push(PATH_NAME.REGISTER);
  };
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (anchor: Anchor, open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' || (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor: Anchor) => (
    <Box
      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <div className="text-end m-1">
        <IconButton onClick={toggleDrawer(anchor, true)} color="primary">
          <CloseIcon />
        </IconButton>
      </div>

      <List className="mobile-menu">
        <ListItem disablePadding>
          <ListItemButton className="mobileMenuItem" onClick={openCart}>
            <ListItemIcon className="menu-iocn">
              <div className="cart-icon">
                <img src={IMAGES_PATH.icons.bag} alt="cart-icon" />
                <div className="badge">{cartItems.length}</div>
              </div>
            </ListItemIcon>
            <ListItemText className="link-test">My Cart</ListItemText>
          </ListItemButton>
        </ListItem>
        {isLoggedIn ? (
          <ListItem disablePadding>
            <ListItemButton className="mobileMenuItem" href={PATH_NAME.PROFILE}>
              <ListItemIcon className="menu-iocn">
                <div className="user-icon">
                  <img src={IMAGES_PATH.icons.user} alt="user-icon" />
                </div>
              </ListItemIcon>
              <ListItemText className="link-test">Profile</ListItemText>
            </ListItemButton>
          </ListItem>
        ) : (
          <ListItem disablePadding>
            <ListItemButton className="mobileMenuItem" href={PATH_NAME.PROFILE}>
              <ListItemIcon className="menu-iocn">
                <div className="user-icon">
                  <img src={IMAGES_PATH.icons.user} alt="user-icon" />
                </div>
              </ListItemIcon>
              <ListItemText className="link-test">My Account</ListItemText>
            </ListItemButton>
          </ListItem>
        )}
      </List>
    </Box>
  );

  return (
    <React.Fragment>
      {role === USER_ROLE.ADMIN ? null : (
        <>
          <Navbar sticky="top" className="bg-white border-bottom shadow-sm main-navbar d-none d-lg-block">
            <Container>
              <Navbar.Brand href={PATH_NAME.ROOT} className="d-flex align-items-center">
                <img src={IMAGES_PATH.logo.brandLogo} alt="logo" className="img-fluid " />
              </Navbar.Brand>
              <Navbar.Toggle aria-controls="navbarScroll" />
              <Navbar.Collapse id="navbarScroll">
                <div className="d-flex ms-auto align-items-center">
                  <div className="cart-icon" onClick={openCart}>
                    <img src={IMAGES_PATH.icons.bag} alt="cart-icon" />
                    <div className="badge">{cartItems.length}</div>
                  </div>
                  {!authService.getAccessToken() ? (
                    <div className="user-icon" onClick={() => history.push(PATH_NAME.PROFILE)}>
                      <img src={IMAGES_PATH.icons.user} alt="user-icon" />
                      {isLoggedIn ? <div className="user-name">{user?.first_name}</div> : null}
                    </div>
                  ) : (
                    <div className="user-icon" onClick={() => history.push(PATH_NAME.PROFILE)}>
                      <img src={IMAGES_PATH.icons.user} alt="user-icon" />
                    </div>
                  )}
                </div>
              </Navbar.Collapse>
            </Container>
          </Navbar>

          <Navbar sticky="top" className="border-bottom shadow-sm main-navbar bg-white d-block d-lg-none">
            <Container>
              <Navbar.Brand href={PATH_NAME.ROOT} className="d-flex align-items-center">
                <img src={IMAGES_PATH.logo.brandLogo} alt="logo" className="img-fluid" />
              </Navbar.Brand>
              <Navbar.Toggle aria-controls="navbarScroll" />
              <Navbar.Collapse id="navbarScroll">
                <div className="d-flex ms-auto align-items-center">
                  {(['right'] as const).map((anchor) => (
                    <React.Fragment key={anchor}>
                      <IconButton onClick={toggleDrawer(anchor, true)} size="medium">
                        <MenuIcon fontSize="large" />
                      </IconButton>
                      <Drawer
                        className="main-navbar mobile-menu"
                        anchor={anchor}
                        open={state[anchor]}
                        onClose={toggleDrawer(anchor, false)}
                      >
                        {list(anchor)}
                      </Drawer>
                    </React.Fragment>
                  ))}
                </div>
              </Navbar.Collapse>
            </Container>
          </Navbar>
        </>
      )}
    </React.Fragment>
  );
};

const mapStateToProps = (state: any) => ({
  cartItems: state.auth.cartItems,
  user: state.auth.user?.user,
});

export default connect(mapStateToProps)(MainNavbar);
